import { useCallback } from "react";

import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src";

import {
    KANBAN_TEAM_MANAGED_KEY,
    SCRUM_TEAM_MANAGED_KEY
} from "../models/percieved-provisioning";

import { useCloudStatus } from "./use-cloud-status";
import { useRecommendedTemplate } from "./use-recommended-template";
import { useSearchParameters } from "./use-search-parameters";

export const useCreateSampleProject = () => {
    const { cloudId } = useCloudStatus();
    const stargateClient = useBxpWebStargateClient();
    const { teamType = "software-development" } = useSearchParameters();
    const templateId = useRecommendedTemplate();

    const createSampleProject = useCallback(async () => {
        try {
            const template = getTemplateNameFromTemplateId(templateId);

            const { projectId } = await stargateClient.sampleProjectCreate({
                cloudId,
                teamType,
                template
            });

            const promises: Promise<boolean>[] = [];

            const putSampleProjectUserPropertyPromise =
                stargateClient.putSampleProjectUserProperties({
                    projectId,
                    tenantId: cloudId
                });

            promises.push(putSampleProjectUserPropertyPromise);

            await Promise.all(promises);

            return projectId;
        } catch (error) {
            // TODO: Send analaytics event to indicate that the sample project was not created.
            console.error("Error creating sample project:", error);
        }

        return undefined;
    }, [stargateClient, cloudId, teamType, templateId]);

    return { createSampleProject };
};

function getTemplateNameFromTemplateId(templateId: string) {
    switch (templateId) {
        case KANBAN_TEAM_MANAGED_KEY:
            return "KANBAN";
        case SCRUM_TEAM_MANAGED_KEY:
            return "SCRUM";
        default:
            throw new Error(
                `TemplateId ${templateId} is not supported for sample project creation.`
            );
    }
}
